import React from 'react';
import {
  Card,
  Layout,
  SkeletonBodyText,
  SkeletonDisplayText,
  SkeletonPage,
} from '@shopify/polaris';

// Shown while App.js's shopInfo/permissions gate is still closed — i.e. this
// is the very first thing a merchant sees on every embedded session. The old
// full-viewport <Spinner/> gave the browser no LCP candidate (nothing to
// score until the real dashboard painted seconds later) and reserved no
// layout, so the spinner→content swap was one big shift. This skeleton
// mirrors dashboardV2's DashboardSkeleton card stack so the
// gate→route-skeleton→content sequence keeps the same silhouette throughout.
// NOTE: must render inside PolarisProvider (App.js wraps the gate now).
const WholePageLoading = () => (
  <SkeletonPage title=" ">
    <Layout>
      <Layout.Section>
        <Card>
          <SkeletonDisplayText size="small" />
          <div style={{ marginTop: 12 }}>
            <SkeletonBodyText lines={2} />
          </div>
        </Card>
      </Layout.Section>
      <Layout.Section>
        <Card>
          <SkeletonBodyText lines={4} />
        </Card>
      </Layout.Section>
      <Layout.Section>
        <div
          style={{ minHeight: 320, borderRadius: 12, background: '#f6f6f7' }}
          aria-hidden="true"
        />
      </Layout.Section>
    </Layout>
  </SkeletonPage>
);

export default WholePageLoading;
